export default "__VITE_ASSET__BaG57t92__"